import Sidebar from "./Sidebar";
import { Bell, Search } from "lucide-react";
import { Toaster } from "sonner";

export default function Layout({ children }) {
  return (
    <div className="flex min-h-screen bg-slate-50">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <header className="h-16 border-b border-slate-200 bg-white/95 backdrop-blur-md px-6 flex items-center gap-4 sticky top-0 z-30">
          <div className="relative flex-1 max-w-xl">
            <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              data-testid="global-search"
              placeholder="Search candidates, job orders, companies…"
              className="w-full pl-9 pr-4 h-9 rounded-md border border-slate-200 bg-slate-50 text-sm focus:bg-white focus:border-sky-500 outline-none"
            />
          </div>
          <div className="flex items-center gap-3">
            <span data-testid="ai-agents-status" className="hidden md:inline-flex items-center gap-1.5 text-[11px] font-semibold px-2.5 py-1 rounded-full bg-sky-50 text-sky-700 border border-sky-200">
              <span className="w-1.5 h-1.5 rounded-full bg-sky-500"></span> AI Engine · Ready
            </span>
            <button data-testid="notifications-btn" className="relative w-9 h-9 rounded-md hover:bg-slate-100 flex items-center justify-center text-slate-600">
              <Bell size={17} />
            </button>
          </div>
        </header>
        <main className="flex-1 p-6 lg:p-8 max-w-[1700px] w-full mx-auto">
          {children}
        </main>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
}
